import React from 'react'

import Modal from 'react-modal';

const _customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    overflowY: 'auto',
    zIndex: 1000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: 0,
    maxHeight: '90vh',
    overflowY: 'auto',
    borderRadius: "16px"
  },
};
const CModal = ({customStyles, ...props}) => {
  return <Modal 
    {...props} 
    style={customStyles ?? _customStyles}
    htmlOpenClassName="modal-open"
    bodyOpenClassName="modal-open"
  />
}
Modal.setAppElement('#root');

export default CModal